import { COMMENT_TYPES } from 'modules/admin-panel/utils';

export interface IMarksAverages {
	all: number[];
	min: number[];
	mid: number[];
	max: number[];
}

export const getCurrentMarks = (
	type: string,
	marksAverage: IMarksAverages,
): number[] => {
	const { all, mid, min, max } = marksAverage;

	switch (type) {
		case COMMENT_TYPES.all:
			return all;
		case COMMENT_TYPES.neutral:
			return mid;
		case COMMENT_TYPES.negative:
			return min;
		case COMMENT_TYPES.positive:
			return max;
		default:
			return all;
	}
};
